import { AuthApi } from "./auth.api";
import authService from "./auth.service";
import * as AuthVariant from "./auth.variant";

export const Auth = {
  authService,
  AuthApi,
  AuthVariant,
};

// DTO 타입들은 별도 export
export type * as AuthDtoT from "./auth.dto";

// Variant 타입들도 export
export type { AuthenticatedUser, TokenInfo } from "./auth.variant";
